<template>
    <div class="d-flex flex-row">
        <div id="queryNameContainer" class="query-column">
            <dx-check-box
                v-on:valueChanged="toggleInputs"
                v-model="rowEnabled"
                class="query-name-switch"
                :text="queryName"
            />
        </div>
        <div class="query-column" id="input1-wrapper">
            <dx-range-slider
                id="input1"
                :disabled="!rowEnabled"
                ref="radioGroup"
                :min="min"
                :max="max"
                :label="label"
                :tooltip="tooltip"
                v-on:valueChanged="newQueryValue($event)"
            />
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { DxRangeSlider } from "devextreme-vue/range-slider";
import { DxCheckBox } from "devextreme-vue/check-box";
import { DxTooltip } from "devextreme-vue/tooltip";

export default {
    components: {
        DxRangeSlider,
        DxCheckBox,
    },
    data() {
        return {
            from: 40,
            to: 60,
            rowEnabled: false,
            label: {
                visible: true,
                position: "top",
            },
            tooltip: {
                enabled: true,
                showMode: "always",
                position: "top",
            },
        };
    },
    props: {
        queryName: String,
        queryField: String,
        min: Number,
        max: Number,
        category: String,
    },
    computed: {
        ...mapState({ advancedQueryCriteria: (state) => state.advancedQueryCriteria }),
    },
    methods: {
        ...mapActions([`updateRelationalQuery`, "deleteRelationalQuery"]),
        reboot() {
            this.rowEnabled = false;
        },
        toggleInputs: function (event) {
            if (!this.rowEnabled) {
                this.answer = null;
                this.deleteRelationalQuery({
                    queryField: this.queryField,
                    category: this.category,
                });
            } else {
                this.to = 40;
                this.from = 60;
                this.newQueryValue({value: [this.from, this.to]});
            }
        },
        newQueryValue: function (event) {
            if (event.value !== null)
                this.updateRelationalQuery({
                    queryField: this.queryField,
                    value: { from: event.value[0], to: event.value[1] },
                    category: this.category,
                });
        },
    },
    mounted() {
        this.rowEnabled = false;
    },
};
</script>

<style scoped>
>>> .dx-checkbox-container {
    display: -webkit-inline-box !important;
}

#input1 {
    width: 100%;
}

#input1-wrapper {
    width: 400px;
}

#queryNameContainer {
    flex: 0 1 220px;
}

div:nth-child(n + 2) {
    float: right;
}

[type="text"] {
    width: 150px;
    height: 15px;
}

.btn {
    padding: 0px;
}

.input-append {
    position: relative;
    left: -1px;
    top: 8px;
}

.input-append > div {
    padding-left: 0px;
    margin-left: 0px;
}

.input-group-btn > .btn {
    padding: 10px;
}

.d-flex .flex-column {
    position: relative;
    left: -31px;
}

.input-group-addon span {
    padding-left: 10px;
}

#dateValueFrom,
#dateValueTo {
    border-top-right-radius: 0rem;
    border-bottom-right-radius: 0rem;
}

.dx-switch,
.dx-checkbox {
    display: flex !important;
    margin-right: 10px;
}

.query-column {
    display: flex;
    justify-content: flex-start;
    align-content: center;
}

.row {
    width: 100% !important;
}

.date-filter-container {
    margin-left: 0 !important;
}

.from-to-label {
    min-width: 110px;
}

.date-filter-container {
    padding-bottom: 5px;
}

/* VSCode and VS will underline the >>> as an error, but it's actually the Vue.js 'deep' combinator
    All it does is allow you to affect child components in a scoped stylesheet
    But it doesn't play nicely with commas, hence the repeating styles */

>>> span.dx-checkbox-text {
    margin-bottom: -20px;
}

>>> .dx-checkbox-container {
    display: flex;
    align-self: center;
}

>>> .dx-checkbox-icon {
    display: flex;
    align-self: center;
}

>>> .dx-checkbox-text {
    display: flex;
    align-self: center;
}

>>> .dx-checkbox-checked .dx-checkbox-icon {
    color: #0275d8;
}

>>> span {
    font-weight: lighter;
}

>>> .dx-item-content {
    font-weight: lighter;
}

@media only screen and (max-width: 1200px) {
    #queryNameContainer {
        padding-bottom: 30px !important;
    }
}
</style>
